(ns quuppa.qsm.ui-state.subs
  (:require [re-frame.core :as rf]))

(defn get-sidebar-form [db page-key form-key]
  (get-in db [:ui-state page-key :sidebar form-key :data]))

(rf/reg-sub ::ui-state
  (fn [db [_ page-key & path]]
    (get-in db (apply conj [:ui-state page-key] path))))

(rf/reg-sub ::sidebar-form-data
  (fn [db [_ page-key form-key]]
    (get-sidebar-form db page-key form-key)))

(rf/reg-sub ::sidebar-error
  (fn [db [_ page-key]]
    (get-in db [:ui-state page-key :sidebar :error])))
